import Vue from 'vue';

import BootstrapVue from 'bootstrap-vue';

import '@/styles/main.scss';

Vue.use(BootstrapVue);
